// extracted by mini-css-extract-plugin
export default {"small":"edit-bag_small__dkyN9"};